import { RequestApi } from '../helpers';

const chargeSkatingPurchase = async (data: any) => {
  const response = await RequestApi.post(`/payments/charge-tickets`, data);
  return response;
};

const chargeHockeyPurchase = async (data: any) => {
  const response = await RequestApi.post(`/payments/charge-hockey`, data);
  return response;
};

const chargeLessonsPurchase = async (data: any) => {
  const response = await RequestApi.post(`/payments/charge-lessons`, data);
  return response;
};

const chargeSeasonPurchase = async (data: any) => {
  const response = await RequestApi.post(`/payments/charge-season`, data);
  return response;
};

const chargePartiesPurchase = async (data: any) => {
  const response = await RequestApi.post(`/payments/charge-parties`, data);
  return response;
};

const paymentService = {
  chargeSkatingPurchase,
  chargeHockeyPurchase,
  chargeLessonsPurchase,
  chargeSeasonPurchase,
  chargePartiesPurchase,
};

export default paymentService;
